const DESKTOP_BREAKPOINT = "64rem";

// iPadOS 13+ reports itself as desktop Safari (`navigator.platform` is "MacIntel"), so touch
// support is the only way left to tell an iPad apart from an actual Mac. Older iPadOS still
// identifies itself as "iPad" in the user agent.
const isIpad = () =>
  /ipad/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export const isIos = (): boolean => /iphone|ipod/i.test(navigator.userAgent) || isIpad();

export const isAndroid = (): boolean => /android/i.test(navigator.userAgent);

export const isPhoneOrTabletDevice = (): boolean => isIos() || isAndroid();

export const isDesktopViewport = (): boolean => window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT})`).matches;
